import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ChatbotPanel } from '@fourthwall/module-ai-kit'

import { useAIKitDashboard } from '../AIKitDashboardProvider'

/**
 * Wrapper component that integrates ChatbotApp with React Router
 * Provides navigation callback and current pathname to the chatbot module
 */
export const DashboardChatbot: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { closeChatbot } = useAIKitDashboard()

  const handleNavigate = React.useCallback(
    (url: string) => {
      navigate(url)
    },
    [navigate],
  )

  return (
    <ChatbotPanel
      variant="sidebar"
      onClose={closeChatbot}
      onNavigate={handleNavigate}
      currentPathname={location.pathname}
    />
  )
}
